import {
  ICalloutContentStyleProps,
  ICalloutContentStyles,
} from "@fluentui/react/lib/Callout";
import { HighContrastSelector, ITheme } from "@fluentui/react/lib/Styling";

import {
  commonHighContrastOutlineToggledOn,
  getStandardControlSemanticColorsWithTheme,
} from "@1js/acui-common";
import { isThemingEnabled } from "@1js/acui-theme";

export const getStyles = (
  theme: ITheme,
  hideTooltip?: boolean,
  delayTooltip?: boolean
): ((props: ICalloutContentStyleProps) => ICalloutContentStyles) => {
  return (props: ICalloutContentStyleProps): ICalloutContentStyles => {
    const { overflowYHidden, calloutWidth, beakWidth } = props;
    const semanticColors = getStandardControlSemanticColorsWithTheme(theme);

    return {
      container: [
        {
          position: "relative",
          selectors: {
            ".ms-Tooltip": {
              padding: "4px 12px",
            },
          },
        },
        hideTooltip && { visibility: "hidden" },
      ],
      root: [
        {
          position: "absolute",
          boxSizing: "border-box",
          borderRadius: 2,
          border: `1px solid ${semanticColors.borderColor}`,
          boxShadow:
            "0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)",
        },
        !!calloutWidth && { width: calloutWidth },
        !delayTooltip && {
          animationDelay: "0s",
        },
        delayTooltip && {
          animationDelay: "500ms",
        },
      ],
      beak: {
        position: "absolute",
        backgroundColor: semanticColors.defaultBackgroundColor,
        boxSizing: "border-box",
        transform: "rotate(45deg)",
        height: beakWidth,
        width: beakWidth,
        border: `1px solid ${semanticColors.borderColor}`,
      },
      beakCurtain: [
        {
          position: "absolute",
          backgroundColor: semanticColors.defaultBackgroundColor,
          borderRadius: 2,
          borderColor: "transparent",
          minWidth: 20,
          selectors: {
            [HighContrastSelector]: {
              outline: "none",
            },
          },
        },
        commonHighContrastOutlineToggledOn,
      ],
      calloutMain: [
        {
          backgroundColor: semanticColors.defaultBackgroundColor,
          overflowX: "hidden",
          overflowY: "auto",
          position: "relative",
          whiteSpace: "pre-line",
          userSelect: "none",
          selectors: {
            p: {
              color: isThemingEnabled() ? semanticColors.textColor : "#323130",
              fontSize: 12,
            },
          },
        },
        overflowYHidden && {
          overflowY: "hidden",
        },
      ],
    };
  };
};
